// ============================================================
// SALİHLİ OTO ÇEKİCİ — TEK KAYNAK YAPILANDIRMA DOSYASI
// Telefon, WhatsApp, adres, hizmetler, galeri, bölgeler buradan
// yönetilir. Burada değiştirilen her şey sitenin tamamına yansır.
// NOT: Telefon numarası değişirse public/index.html içindeki
// JSON-LD (schema.org) "telephone" alanını da güncelleyin.
// ============================================================
import {
  Car,
  CarFront,
  Container,
  Tractor,
  Construction,
  Star,
  Clock,
  ShieldCheck,
  MapPin,
  Truck,
  Users,
  Phone,
  Camera,
  Route,
  Globe,
} from "lucide-react";

export const siteConfig = {
  businessName: "Salihli Oto Çekici",
  domain: "https://salihliotocekici.com",

  phone: {
    display: "0506 239 45 45",
    tel: "+905062394545",
  },

  whatsapp: {
    number: "905062394545",
    defaultMessage:
      "Merhaba, oto kurtarma/araç taşıma hizmeti almak istiyorum. Konumumu sizinle paylaşıyorum.",
    intercityMessage:
      "Merhaba, şehirler arası araç taşıma fiyatı almak istiyorum. Aracın alınacağı şehir: ___ Teslim edileceği şehir: ___ Araç marka/model: ___",
  },

  address: {
    locality: "Salihli",
    region: "Manisa",
    country: "Türkiye",
  },

  logoUrl: "/img/logo-wide.webp",

  googleMapsEmbedUrl: "https://www.google.com/maps?q=Salihli%2C%20Manisa&output=embed",
  googleBusinessUrl: "https://share.google/UUOnkG6027t8CNfFC",

  social: [],

  nav: [
    { label: "Ana Sayfa", hash: "top" },
    { label: "Hizmetlerimiz", hash: "hizmetler" },
    { label: "Yaptığımız İşler", hash: "isler" },
    { label: "Hizmet Bölgeleri", hash: "bolgeler" },
    { label: "Hakkımızda", hash: "hakkimizda" },
    { label: "İletişim", hash: "iletisim" },
  ],

  heroTrust: [
    "Salihli Merkezli",
    "7/24 Hizmet",
    "Manisa • İzmir • Ankara • İstanbul",
    "Türkiye Geneli",
  ],

  trustStrip: [
    { icon: Clock, title: "7/24", sub: "Kesintisiz Hizmet" },
    { icon: ShieldCheck, title: "Güvenli", sub: "Taşıma" },
    { icon: MapPin, title: "Salihli ve Tüm", sub: "Manisa Çevresi" },
    { icon: Truck, title: "Şehirler Arası", sub: "Araç Taşıma" },
    { icon: Users, title: "Tecrübeli", sub: "Hizmet" },
    { icon: Car, title: "Her Araç Tipine", sub: "Uygun Çözümler" },
  ],

  // Tüm fotoğraflar işletmenin GERÇEK araç ve iş fotoğraflarıdır.
  // "position" değeri object-position ile kırpma odağını ayarlar.
  services: [
    {
      title: "Oto Kurtarma & Oto Çekici",
      desc: "Arızalı, yolda kalan, kaza yapan ve taşınması gereken araçlar için 7/24 oto kurtarma hizmeti.",
      icon: Car,
      image: "salihli-oto-kurtarma",
      position: "center 55%",
      imageAlt: "Salihli oto kurtarma — kurtarıcı üzerinde taşınan binek otomobil",
    },
    {
      title: "Ticari Araç Taşıma",
      desc: "Panelvan, minibüs ve hafif ticari araçlar için profesyonel taşıma çözümleri.",
      icon: Container,
      image: "salihli-panelvan-tasima",
      position: "center 40%",
      imageAlt: "Salihli panelvan taşıma — kurtarıcı üzerinde beyaz panelvan minibüs",
    },
    {
      title: "Traktör & Tarım Makinesi Taşıma",
      desc: "Traktör ve uygun tarım makinelerinin güvenli şekilde taşınması.",
      icon: Tractor,
      image: "salihli-traktor-tasima",
      position: "center 55%",
      imageAlt: "Salihli traktör taşıma — kurtarıcı üzerinde kırmızı traktör",
    },
    {
      title: "İş Makinesi Taşıma",
      desc: "Uygun ölçü ve ağırlıktaki mini iş makineleri için taşıma hizmeti.",
      icon: Construction,
      image: "salihli-is-makinesi-tasima",
      position: "center 45%",
      imageAlt: "Salihli iş makinesi taşıma — kurtarıcı üzerinde Hitachi mini ekskavatör",
    },
    {
      title: "Kazalı Araç Kurtarma",
      desc: "Kaza sonrası hareket edemeyen ve hasarlı araçların güvenli şekilde taşınması.",
      icon: CarFront,
      image: "salihli-kazali-arac-kurtarma",
      position: "center 55%",
      imageAlt: "Salihli kazalı araç kurtarma — kurtarıcı üzerinde hasarlı ambulans",
    },
    {
      title: "Özel / Klasik Araç Taşıma",
      desc: "Klasik, özel ve özen gerektiren araçlar için dikkatli taşıma hizmeti.",
      icon: Star,
      image: "salihli-klasik-arac-tasima",
      position: "center 50%",
      imageAlt: "Salihli klasik araç taşıma — kurtarıcı üzerinde kırmızı klasik otomobil, gece",
    },
  ],

  // SADECE gerçek iş fotoğrafları. Eski iki katlı kasa fotoğrafı kullanılmıyor.
  gallery: [
    {
      image: "salihli-pickup-tasima-gece",
      title: "4x4 Pickup Kurtarma",
      tag: "Gece Operasyonu",
      position: "center 55%",
      alt: "Salihli oto çekici — gece, amber ışıkları yanan kurtarıcıya yüklenen 4x4 pickup",
    },
    {
      image: "salihli-panelvan-tasima",
      title: "Panelvan Taşıma",
      tag: "Ticari Araç",
      position: "center 40%",
      alt: "Salihli panelvan taşıma — kurtarıcı üzerinde beyaz panelvan minibüs",
    },
    {
      image: "salihli-traktor-tasima",
      title: "Traktör Taşıma",
      tag: "Tarım Aracı",
      position: "center 55%",
      alt: "Salihli traktör taşıma — kurtarıcı üzerinde kırmızı traktör",
    },
    {
      image: "salihli-kazali-arac-kurtarma",
      title: "Kazalı Araç Kurtarma",
      tag: "Kaza Sonrası",
      position: "center 55%",
      alt: "Salihli kazalı araç kurtarma — kurtarıcı üzerinde hasarlı ambulans",
    },
    {
      image: "salihli-klasik-arac-tasima",
      title: "Klasik Araç Taşıma",
      tag: "Özel Araç • Gece",
      position: "center 50%",
      alt: "Salihli klasik araç taşıma — kurtarıcı üzerinde kırmızı klasik otomobil, gece benzin istasyonu",
    },
    {
      image: "salihli-is-makinesi-tasima",
      title: "Mini Ekskavatör Taşıma",
      tag: "İş Makinesi",
      position: "center 45%",
      alt: "Salihli iş makinesi taşıma — kurtarıcı üzerinde Hitachi mini ekskavatör",
    },
    {
      image: "salihli-oto-kurtarma",
      title: "Binek Otomobil Taşıma",
      tag: "Oto Çekici",
      position: "center 55%",
      alt: "Salihli oto kurtarma — kurtarıcı üzerinde taşınan binek otomobil",
    },
    {
      image: "salihli-traktor-yukleyici-tasima",
      title: "Traktör & Yükleyici Taşıma",
      tag: "Tarım & İş",
      position: "center 50%",
      alt: "Salihli traktör taşıma — kurtarıcı üzerinde ön yükleyicili traktör",
    },
  ],

  galleryScope: ["Binek Araç", "SUV", "Pickup", "Hafif Ticari", "Panelvan", "Traktör", "İş Makinesi"],

  routes: [
    { from: "İzmir", to: "Ankara", note: "Düzenli Araç Taşıma" },
    { from: "İzmir", to: "İstanbul", note: "Düzenli Araç Taşıma" },
  ],

  primaryRegion: "Salihli",
  regions: ["Manisa", "İzmir", "Ankara", "İstanbul", "Alaşehir", "Ahmetli", "Turgutlu", "Kula", "Sart"],

  whyUs: [
    { icon: Phone, title: "7/24 Ulaşılabilirlik", desc: "Gece gündüz arayabilir, WhatsApp'tan konum gönderebilirsiniz." },
    { icon: Camera, title: "Gerçek Araç & Gerçek İşler", desc: "Sitedeki tüm fotoğraflar kendi aracımız ve gerçek işlerimizdir." },
    { icon: ShieldCheck, title: "Güvenli Araç Taşıma", desc: "Aracınız kayar kasa ile sabitlenerek taşınır." },
    { icon: Car, title: "Binek ve Ticari Araçlar", desc: "Otomobilden panelvana geniş taşıma kapasitesi." },
    { icon: Tractor, title: "Traktör & İş Makinesi", desc: "Tarım ve iş makineleri için uygun ekipman." },
    { icon: Route, title: "Şehirler Arası Taşıma", desc: "İzmir, Ankara ve İstanbul başta olmak üzere düzenli güzergâhlar." },
    { icon: Globe, title: "Türkiye Geneli Hizmet", desc: "Aracınızı Türkiye'nin her noktasına taşıyoruz." },
  ],
};

export const telHref = `tel:${siteConfig.phone.tel}`;

export const waHref = (message = siteConfig.whatsapp.defaultMessage) =>
  `https://wa.me/${siteConfig.whatsapp.number}?text=${encodeURIComponent(message)}`;

export const imgSrc = (name, w = 800) => `/img/${name}-${w}.webp`;

export const imgSrcSet = (name) =>
  `/img/${name}-480.webp 480w, /img/${name}-800.webp 800w, /img/${name}-1200.webp 1200w`;
